<template>
  <v-container fluid class="py-16"
               :style="`background: ${backgroundTopColor}; background: linear-gradient(to bottom, ${backgroundTopColor}, ${backgroundBottomColor});`">
    <v-row class="py-7">
      <v-col cols="12">
        <p v-if="subtitle" :class="`${subtitleColor}--text text-${subtitleSize}`" class="text-center mb-2">
          {{ $t(`${subtitle}`) }}
        </p>
        <h1 :class="`${titleColor}--text text-${titleSize}`" class="text-center font-weight-bold">
          {{ $t(`${title}`) }}
        </h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Headline3',
  components: {
    //
  },
  props: {
    backgroundBottomColor: {
      type: String,
      default: '#2b32b2',
    },
    backgroundTopColor: {
      type: String,
      default: '#1488cc',
    },
    subtitle: {
      type: String,
      default: 'subtitle',
    },
    subtitleColor: {
      type: String,
      default: 'white',
    },
    subtitleSize: {
      type: String,
      default: 'h6',
    },
    title: {
      type: String,
      default: 'title',
    },
    titleColor: {
      type: String,
      default: 'white',
    },
    titleSize: {
      type: String,
      default: 'h3',
    },
  },
  data() {
    return {
      //
    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
